export const authRoles = {
  sa: ["SA"], // Only Super Admin has access
  admin: ["SA", "ADMIN"], // Only SA & Admin has access
  // user: ["SA", "ADMIN", "USER"], // Only SA & Admin & Editor has access
  user: ["SA", "ADMIN", "EDITOR"], // Only SA & Admin & Editor has access
  guest: ["SA", "ADMIN", "USER", "GUEST"] // Everyone has access
};
